import { render, staticRenderFns } from "./LmTextArea.vue?vue&type=template&id=305c8a40&"
import script from "./LmTextArea.vue?vue&type=script&lang=js&"
export * from "./LmTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports